import script from "./Highlights.vue?vue&type=script&setup=true&lang=js"
export * from "./Highlights.vue?vue&type=script&setup=true&lang=js"

import "./Highlights.vue?vue&type=style&index=0&id=1647aa54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1647aa54"]])

export default __exports__